const FinancialDimensionRoutes = [
    {
        path: '',
        name: 'financial-dimension-index',
        component: () => import("@/components/admin/financial-dimension/list.vue")
    },
    {
        path: 'list',
        name: 'list-financial-dimension',
        component: () => import("@/components/admin/financial-dimension/list.vue")
    },
    {
        path: 'form',
        name: 'form-financial-dimension',
        component: () => import("@/components/admin/financial-dimension/form.vue")
    }
];
export default FinancialDimensionRoutes